import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction'
import HttpService from '../../../services/httpService'
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TablePagination, TextField, Select, MenuItem, InputLabel, FormControl,
  Button, Chip, Box, Typography, Tooltip
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 900,
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    marginBottom: 16,
  },
  truncate: {
    display: 'block',
    maxWidth: 220,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tableContainer: {
    maxHeight: 'calc(100vh - 320px)',
  },
  valueCell: {
    display: 'block',
    maxWidth: 220,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const TYPE_OPTIONS = ['Personal Detail', 'Bank Detail', 'Payment', 'Block'];

const TYPE_COLOR = {
  'Personal Detail': '#3b82f6',
  'Bank Detail': '#8b5cf6',
  'Payment': '#059669',
  'Block': '#ef4444',
};

const VendorLogs = (props) => {
  const classes = useStyles();

  const [logs, setLogs] = useState([])
  const [totalDocs, setTotalDocs] = useState(0)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(100)

  const [vendorNameInput, setVendorNameInput] = useState("")
  const [vendorName, setVendorName] = useState("")
  const [type, setType] = useState("")

  const fetchLogs = async (currentPage, limit, vendorNameFilter, typeFilter) => {
    props.setLoading(true)
    try {
      const response = await HttpService.getVendorLogs({
        page: currentPage + 1,
        limit,
        vendorName: vendorNameFilter || undefined,
        type: typeFilter || undefined,
      })
      if (response.data?.success) {
        setLogs(response.data.data || [])
        setTotalDocs(response.data.totalDocs || 0)
      }
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    props.setLoading(false)
  }

  useEffect(() => {
    fetchLogs(page, rowsPerPage, vendorName, type)
    // eslint-disable-next-line
  }, [page, rowsPerPage, vendorName, type])

  const handleChangePage = (_event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleSearch = () => {
    setPage(0)
    setVendorName(vendorNameInput.trim())
  }

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  const handleTypeChange = (e) => {
    setPage(0)
    setType(e.target.value)
  }

  const handleClearFilter = () => {
    setPage(0)
    setVendorNameInput("")
    setVendorName("")
    setType("")
  }
  const renderValue = (value) => {
  const formatted = formatValue(value);

  return (
    <Tooltip title={formatted} arrow placement="top">
      <span className={classes.valueCell}>
        {formatted}
      </span>
    </Tooltip>
  );
};

  const formatValue = (value) => {
    if (value === null || value === undefined || value === '') return '-'
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    return String(value)
  }

  return (
    <Box p={3}>
      <Typography variant="h5" style={{ fontWeight: 600, marginBottom: 16 }}>
        Vendor Logs
      </Typography>

      <div className={classes.filters}>
        <TextField
          label="Search Vendor Name"
          value={vendorNameInput}
          onChange={(e) => setVendorNameInput(e.target.value)}
          onKeyDown={handleSearchKeyDown}
          variant="outlined"
          size="small"
        />
        <Button variant="contained" color="primary" onClick={handleSearch}>
          Search
        </Button>

        <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
          <InputLabel id="type-filter-label">Type</InputLabel>
          <Select
            labelId="type-filter-label"
            label="Type"
            value={type}
            onChange={handleTypeChange}
          >
            <MenuItem value="">All</MenuItem>
            {TYPE_OPTIONS.map((t) => (
              <MenuItem key={t} value={t}>{t}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button variant="outlined" color="secondary" onClick={handleClearFilter}>
          Clear Filter
        </Button>
      </div>

      <Paper>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader className={classes.table} size="small" aria-label="vendor logs table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Date</StyledTableCell>
              <StyledTableCell>Vendor Name</StyledTableCell>
              <StyledTableCell>Type</StyledTableCell>
              <StyledTableCell>Field Name</StyledTableCell>
              <StyledTableCell>Old Value</StyledTableCell>
              <StyledTableCell>New Value</StyledTableCell>
              <StyledTableCell>Remark</StyledTableCell>
              <StyledTableCell>Deal Activity</StyledTableCell>
              <StyledTableCell>Changed By</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs?.map((log) => (
              <StyledTableRow key={log._id}>
                <StyledTableCell>
                  {log.createdAt ? new Date(log.createdAt).toLocaleString("en-IN") : "-"}
                </StyledTableCell>
                <StyledTableCell>{log.vendorId?.name || "-"}</StyledTableCell>
                <StyledTableCell>
                  <Chip
                    label={log.type}
                    size="small"
                    style={{
                      backgroundColor: TYPE_COLOR[log.type] || "#94a3b8",
                      color: "#fff",
                      fontWeight: 600,
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell>{log.fieldName || "-"}</StyledTableCell>
                <StyledTableCell>{renderValue(log.oldValue)}</StyledTableCell>
                <StyledTableCell>{renderValue(log.newValue)}</StyledTableCell>
                <StyledTableCell>
                  {log.remark ? (
                    <Tooltip title={log.remark} arrow>
                      <span className={classes.truncate}>{log.remark}</span>
                    </Tooltip>
                  ) : "-"}
                </StyledTableCell>
                <StyledTableCell>
                  {log.dealActivity ? (
                    <Tooltip title={log.dealActivity} arrow>
                      <span className={classes.truncate}>{log.dealActivity}</span>
                    </Tooltip>
                  ) : "-"}
                </StyledTableCell>
                <StyledTableCell>{log.changedBy?.name || log.changedBy?.email || "-"}</StyledTableCell>
              </StyledTableRow>
            ))}
            {logs?.length === 0 && (
              <TableRow>
                <StyledTableCell colSpan={9} style={{ textAlign: 'center' }}>
                  No logs found
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={totalDocs}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[100, 500, 1000, { label: 'All', value: -1 }]}
      />
      </Paper>
    </Box>
  )
}

export default connect(null, { setLoading, setSnackInfo })(VendorLogs)